import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

import { User } from '@/ts/User'

function Paragraph({ user }: ParagraphProps) {
  const { t } = useTranslation('global')

  return (
    <>
      {user ? (
        <Trans
          i18nKey="global:order_placed_content"
          components={[
            <p className="max-w-xs mx-auto text-lg text-black/60" key={0} />,
            <a
              key={1}
              href="/customer?path=orders"
              className="font-medium text-sbtviolet-550 hover:text-sbtviolet-400"
            />,
          ]}
        />
      ) : (
        <p className="max-w-md mx-auto text-lg text-black/60">
          {t('order_placed')}
        </p>
      )}
    </>
  )
}

interface ParagraphProps {
  user?: User | null
}

export default Paragraph
